/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-04-29 13:36:59
 * @LastEditors: 刘行 liuhang@nextmar.com
 * @LastEditTime: 2025-06-06 16:32:32
 * @FilePath: /zeelool-nextjs/src/components/Coupon/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from '@/i18n/use-translations';
import CouponNormal from './coupon';
import CouponThumbnail from './couponThumbnail';
import { couponDateTransform } from './handler';
import { ICouponProps } from './type';

type CouponType = 'normal' | 'thumbnail';

interface CouponComponentProps extends ICouponProps {
  type: CouponType;
  detail?: any;
}

export default function Coupon({ type = 'normal', detail, ...props }: CouponComponentProps) {
  const t = useTranslations('coupons');
  const currency = useStore((state) => state.currency);
  // 处理detail

  const { id, title, description, disCountText, couponType, isStairs } = couponDateTransform(
    detail,
    false,
    t,
    currency,
  );

  if (type === 'thumbnail') {
    return (
      <CouponThumbnail
        {...props}
        id={id}
        title={title}
        description={description}
        disCountText={disCountText}
        couponType={couponType}
        isStairs={isStairs}
      />
    );
  }
  return <CouponNormal {...props} />;
}
